const searchFilterReducer = (state, action) => {
  const { newValues, type, shouldSearch = true } = action;
  switch (type) {
    case 'update':
      return { ...state, ...newValues, shouldSearch };
    case 'resetSearch':
      return { ...state, shouldSearch: false };
    case 'reset':
      return null;
    default:
      throw new Error();
  }
};

export default searchFilterReducer;
